"use client"; // you’re using hooks / client-only logic

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Head from "next/head";
import { usePathname, useSearchParams } from "next/navigation";

// import your components
import Categories from "../src/components/categories/Categories";
import HomeFastDeliveryCard from "../src/components/fastDeliveryCard/homeFastDeliveryCard";
import Cart from "../src/components/cart/Cart";
import MobileApp from "../src/components/mobileApp/MobileApp";

import BookingProcess from "../src/components/home/bookingProcess/BookingProcess";
import BeautyServices from "../src/components/home/beautyServices/BeautyServices";
import TestimonialSlider from "../src/components/home/testimonialSlider/TestimonialSlider";
import BrandCard from "../src/components/home/brandCard/BrandCard";
import FooterDescription from "../src/components/footerDescription/FooterDescription";
import Slider from "../src/components/slider/Slider";
import TopStrip from "../src/components/home/topStrip/TopStrip";
import SafetyStandard from "../src/components/home/safetyStandard/SafetyStandard";
import HomePageFaqsList from "../src/components/home/homePageFaqsList/HomePageFaqsList";
import ChatPopup from "../src/components/home/ChatPopup";
import CustomizePackage from '@/src/components/customizePackage/CustomizePackage'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

// If you have action creators:
import { listCategory } from "../src/actions/categoryActions";
import { listReview } from "../src/actions/reviewAction";

import { seoData } from "../src/fakeData/seoData";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function Home() {
  const dispatch = useDispatch();

  // Scroll to top on first mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Dispatch category fetch on mount
  useEffect(() => {
    dispatch(listReview());
    dispatch(listCategory());
  }, [dispatch]);

  // Redux state
  const categoryListState = useSelector((state) => state.categoryList);
  const { loading: loadingCategories, error: errorCategories, category } = categoryListState;

  const reviewList = useSelector((state) => state.reviewList);
  const { error, loading, review } = reviewList

  const language = useSelector((state) => state.language.language);
  const location = useSelector((state) => state.location.location);

  const [showScrollButton, setShowScrollButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // SEO
  const { title, description, keywords, author } = seoData.home;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const canonicalUrl = `https://www.doortodoorbeauty.com${pathname}${
    searchParams ? `?${searchParams.toString()}` : ""
  }`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
      </Head>

      <div className="bg-gray-50">
        <div className="min-h-screen">
          <Cart />
          {/* <ChatPopup /> */}

          <div className="bg-white">
            <div className="mx-auto py-5 max-w-screen-2xl px-3 sm:px-10">
              <div className="flex w-full">
                <div className="flex-shrink-0 xl:pr-6 lg:block w-full lg:w-5/5">
                  <Slider />
                </div>
              </div>
              <TopStrip />
            </div>
          </div>

          <div style={{ padding: "20px" }} className="bg-gray-100 ">
            <Categories
              categories={category?.result || []}
              loading={loadingCategories}
              language={language}
              location={location}
            />
            <BookingProcess />
            <BeautyServices />
            <HomeFastDeliveryCard />
            {/* <CustomizePackage /> */}
            <TestimonialSlider review={review} />

            <BrandCard />
          </div>
        </div>
      </div>

      <div style={{ padding: "20px" }} className="bg-gray-100 ">
        <FooterDescription />
        <MobileApp />
        <SafetyStandard />
        <HomePageFaqsList />
      </div>

      {showScrollButton && (
        <button
          className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          ⬆️
        </button>
      )}
    </>
  );
}
